import { Aperture } from "lucide-react";

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const PhotoSlot = ({
  label,
  note = "iNetra photograph — to be placed",
  className = "",
  dark = false,
  icon: Icon = Aperture,
  src,
  alt,
  fit = "cover",
}) => {
  if (src) {
    const contain = fit === "contain";
    return (
      <div
        data-testid={`photo-slot-${slug(label)}`}
        className={`relative overflow-hidden ${contain ? "bg-white" : ""} ${className}`}
      >
        {contain ? (
          <>
            <img
              src={src}
              alt={alt || label}
              loading="lazy"
              className="w-full h-auto block"
            />
            <div className="bg-white border-t border-slate-100 px-4 py-2.5 text-center">
              <p className="text-xs font-bold tracking-wide text-ink">{label}</p>
              {note && <p className="text-[10px] mt-0.5 tracking-wide text-slate-500">{note}</p>}
            </div>
          </>
        ) : (
          <>
            <img
              src={src}
              alt={alt || label}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div
              className="absolute inset-x-0 bottom-0 h-2/5 pointer-events-none"
              style={{ background: "linear-gradient(to top, rgba(7,30,66,0.85), transparent)" }}
              aria-hidden="true"
            />
            <div className="absolute bottom-0 inset-x-0 p-5 text-center">
              <p className="text-sm font-bold tracking-wide text-white drop-shadow">{label}</p>
              {note && <p className="text-[11px] mt-1 tracking-wide text-blue-100/80">{note}</p>}
            </div>
          </>
        )}
      </div>
    );
  }
  return (
  <div
    data-testid={`photo-slot-${slug(label)}`}
    className={`relative overflow-hidden flex flex-col items-center justify-center text-center p-6 ${
      dark ? "bg-ink text-white" : "bg-brand-mist text-ink"
    } ${className}`}
    role="img"
    aria-label={`${label} — supplied iNetra photograph placeholder`}
  >
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        background: dark
          ? "radial-gradient(70% 70% at 50% 30%, rgba(56,132,255,0.28), transparent 70%)"
          : "radial-gradient(70% 70% at 50% 30%, rgba(37,84,235,0.14), transparent 70%)",
      }}
    />
    <div
      className={`absolute inset-4 rounded-[inherit] border pointer-events-none ${
        dark ? "border-white/10" : "border-ink/10"
      }`}
    />
    <Icon className={`relative w-8 h-8 mb-3 ${dark ? "text-aqua-bright" : "text-brand-bright"}`} strokeWidth={1.4} />
    <p className="relative text-sm font-bold tracking-wide">{label}</p>
    <p className={`relative text-[11px] mt-1.5 tracking-wide ${dark ? "text-blue-200/70" : "text-ink/50"}`}>{note}</p>
  </div>
  );
};
